import { render, staticRenderFns } from "./activity_category.vue?vue&type=template&id=5b744fe2&"
import script from "./activity_category.vue?vue&type=script&lang=js&"
export * from "./activity_category.vue?vue&type=script&lang=js&"
import style0 from "./activity_category.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports